import React from 'react'

import './styles.scss'
import Stars from '../stars/stars.component'
const random = require('random')

export function Review(props) {
  const colors = ['#139fae', '#7b1fa2', '#01579b', '#ab47bc', '#cd447a']
  return (
    <div className='ta text review'>
      <div className='header'>
        <span
          className='logo'
          style={{ backgroundColor: colors[random.int(0, colors.length - 1)] }}
        >
          {props.name[0]}
        </span>
        <div className='right'>
          <p className='name'>{props.name}</p>
          <p className='rezensionen'>{props.rezensionen}</p>
        </div>
      </div>
      <Stars rating={1} />
      <div className='date'>{props.date}</div>
      <div className='text'>{props.children}</div>
    </div>
  )
}

export default Review
